<template>
    <private-inner :initial-user="user" v-if="user"></private-inner>
</template>
<script>
import Vue from "vue";
import PrivateInner from "./PrivateInner.vue";
import { EventBus } from "src/bus/eventBus";
import { Services } from "src/services/Services.js";

export default Vue.extend({
    components: {
        PrivateInner,
    },
    data() {
        return {
            user: null,
        };
    },
    async beforeMount() {
        try {
            this.user = await Services.api.user.getMe();

            this.guard(this.$route);
            EventBus.$on("user:updated", this.onUserUpdated);
        } catch (error) {
            console.loge(error);
            this.user = null;
        }
    },
    beforeDestroy() {
        EventBus.$off("user:updated");
    },
    methods: {
        guard(route) {
            if (!this.user) {
                console.log(!this.user);
                this.$router.push({ name: "login" });
            } else if (route.name !== "cgu" && !this.user?.cguAccepted) {
                this.$router.push({ name: "cgu" });
            } else if (route.name !== "account" && this.user?.cguAccepted && !this.user?.profileCompleted) {
                this.$router.push({ name: "account" });
                setTimeout(() => {
                    EventBus.$emit("account:incomplete");
                }, 1000);
            }
        },
        onUserUpdated(user) {
            this.user = user;
        },
    },
    watch: {
        $route(to) {
            this.guard(to);
        },
    },
});
</script>

<style lang="sass" scoped>
::v-deep
    a
        text-decoration: none
        color: $color-text
</style>
